import React from 'react';

import { ButtonGroup } from '@atlaskit/button';

import { EmojiButton } from '@qality/common-components/src/molecules/EmojiButton';

import { useFeedbackDispatch } from '../Feedback.reducer';
import { useFeedback } from '../FeedbackProvider';
import { useFeedbackVisibility } from '../FeedbackVisibilityProvider';
import {
  ActionsWrapperStyled,
  HeaderWrapperStyled,
  ScreenStyled,
} from './Screens.styled';

const EMOJI_SIZE = '24px';

export default function ChooseEmojiScreen(): JSX.Element {
  const dispatch = useFeedbackDispatch();
  const { storeShareFeedbackFlag } = useFeedbackVisibility();
  const { saveFeedbackRating } = useFeedback();

  const handleBadEmojiClick = (rating: 1 | 2) => {
    storeShareFeedbackFlag();

    saveFeedbackRating({ rating });

    dispatch({
      type: 'click-bad-emoji',
    });
  };

  const handleGoodEmojiClick = (rating: 3 | 4) => {
    storeShareFeedbackFlag();

    saveFeedbackRating({ rating });

    dispatch({
      type: 'click-good-emoji',
    });
  };

  return (
    <ScreenStyled>
      <HeaderWrapperStyled>
        <h5>Do you like this app?</h5>
        <div>Give us quick feedback!</div>
      </HeaderWrapperStyled>
      <ActionsWrapperStyled justifyContent='center'>
        <ButtonGroup>
          <EmojiButton
            tooltipProps={{ content: 'I hate it' }}
            emojiProps={{ emoji: '😡', label: 'Enraged face' }}
            size={EMOJI_SIZE}
            onClick={() => {
              handleBadEmojiClick(1);
            }}
          />
          <EmojiButton
            tooltipProps={{ content: 'It could be better...' }}
            emojiProps={{
              emoji: '😥',
              label: 'Sad but Relieved Face',
            }}
            size={EMOJI_SIZE}
            onClick={() => {
              handleBadEmojiClick(2);
            }}
          />
          <EmojiButton
            tooltipProps={{ content: 'I like it' }}
            emojiProps={{
              emoji: '😊',
              label: 'Smiling Face with Smiling Eyes',
            }}
            size={EMOJI_SIZE}
            onClick={() => {
              handleGoodEmojiClick(3);
            }}
          />
          <EmojiButton
            tooltipProps={{ content: 'I love it' }}
            emojiProps={{
              emoji: '😍',
              label: 'Smiling Face with Heart-Eyes',
            }}
            size={EMOJI_SIZE}
            onClick={() => {
              handleGoodEmojiClick(4);
            }}
          />
        </ButtonGroup>
      </ActionsWrapperStyled>
    </ScreenStyled>
  );
}
